import React, { useState ,useEffect} from 'react';
import "./createRoleTemplate.css"
import { Modal } from 'react-bootstrap';
import into_icon from "../../../../assets/global_assets/create_data_imgs/into_icon.png"
function CreateRoleTemplate({ open, handleClose, formValues, handleChange, handleSubmit, userRole }) {
    const [menuItems ,setMenuItems] = useState();

    useEffect(() => {
        if (userRole === "SuperAdmin") {
          setMenuItems(["Admin", "Processor", "Client"]);
        } else if (userRole === "Admin") {
          setMenuItems(["Processor", "Client"]);
        } else if (userRole === "Processor") {
          setMenuItems(["Client"]);
        } else {
          setMenuItems([]);
        }
      }, [userRole]);
      const handleKeyDown = (e) => {
        if (e.key === " " && e.target.value.length === 0) {
          e.preventDefault();
        }
      };
  return (
    <Modal 
      show={open} 
      onHide={handleClose} 
      centered 
      dialogClassName="custom-modal-dialog"
      backdrop="static"
      keyboard={false}
      style={{ zIndex: "9999" }}
      className='bg-transparent'
    >
      <div className="row d-flex justify-content-center align-items-center w-100 bg-transparent" style={{ marginTop:"10px" }}>
        <div className="bg-white text-white " style={{ minWidth: "580px" ,padding:"5px",borderRadius:"10px",overflow:"hidden",marginLeft:"20px"}}>
        {/* <button type="button" className="btn-close custom-btn-close" onClick={handleClose} aria-label="Close"></button> */}
        <div className="row createRoleTableMainContainer rounded">
          <div className="col-md-12">
          <div className="row">
          <div className="close-btn-div">
            <button type="button" className=" float-end bg-light  " onClick={handleClose} aria-label="Close"><img src={into_icon} alt="" /></button>

          </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="createFormTitle text-dark">
                  <form onSubmit={handleSubmit}>
                  <div className="title">
                    <h5>Create Role</h5>
                    <p>Define the role by specifying its name and base permissions. Roles help manage user access and capabilities in your system.</p>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="row inputdivrow">                    
                        <div className="col-md-6 inputdiv">
                          <div class="form-group">
                            <label for="roleName">Role Name <span className="text-danger">*</span></label>
                            <input type="text" class="form-control" id="roleName" name="role_name" placeholder="Enter Your Role Name" value={formValues.roleName} onChange={handleChange} onKeyDown={handleKeyDown} required/>
                          </div>
                          
                        </div>
                        <div className="col-md-6 inputdiv">                    
                          <div class="form-group">
                            <label for="baseRole">Base Role <span className="text-danger">*</span></label>
                            <select class="" id="baseRole" name="base_role"
                              value={formValues.base_role}
                              onChange={handleChange} 
                              onKeyDown={handleKeyDown}
                              required
                            
                            > 
                              <option value="">--select--</option>                       
                              {menuItems && menuItems.length > 0 ? (
                              menuItems.map((role) => (
                                  <option value={role}>
                                  {role}
                                  </option>
                              ))
                              ) : (
                              <option value="">
                                  --select--
                              </option>
                              )}
                            </select>
                          </div>                   
                        </div>
                      </div>
                      <div className="col-md-12" style={{ marginTop:"-4px" }}>
                        <div class="form-group">
                          <label for="roleName">Role Description <span className="text-danger">*</span></label>
                          <input type="text" name="role_description" class="form-control descriptionInput" id="roleName" placeholder="Role Description" onChange={handleChange} onKeyDown={handleKeyDown} value={formValues.roleDescription} required/>
                        </div>
                      </div>  
                      <div className="col-md-12 mt-4 ">
                        <button className=" w-100 btn formSubmitBtn" type='submit'>Submit</button>
                        </div>                 
                    </div>
                  </div>
                  </form>
              </div>
            </div>
          </div>
          </div>
        </div>
        </div>
      </div>
    </Modal>

  );
}

export default CreateRoleTemplate;
